import {
  SHOW_INDICATOR_TEMPLATES,
  CLEAR_INDICATOR_TEMPLATES,
  FETCH_INDICATOR_TEMPLATE,
  CLEAR_INDICATOR_TEMPLATE,
} from '@constants/actionTypes';

export function showIndicatorTemplates(payload) {
  return { type: SHOW_INDICATOR_TEMPLATES, payload };
}

export function clearIndicatorTemplates() {
  return { type: CLEAR_INDICATOR_TEMPLATES };
}

export function fetchIndicatorTemplate(payload) {
  return { type: FETCH_INDICATOR_TEMPLATE, payload };
}

export function clearIndicatorTemplate() {
  return { type: CLEAR_INDICATOR_TEMPLATE };
}
